module.exports = __webpack_public_path__ + "media/images/pic/teachers/katarzyna-stanko-56ce91561acccf94da08072f639e4e7e.webp";